/**
 * @since 2026-04-21
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import "./OverrideList.scss";

const KIND_LABELS = {
  startDate: "Start date",
  threshold: "Threshold",
  acknowledgment: "Acknowledged",
  dateRangeException: "Exception window",
};

const describe = (override) => {
  switch (override.kind) {
    case "startDate":
      return `From ${override.value}`;
    case "threshold":
      return `${override.parameterName} = ${override.value}`;
    case "acknowledgment":
      return "Severity forced to OK";
    case "dateRangeException":
      return `${override.startDate} → ${override.endDate}`;
    default:
      return "";
  }
};

const OverrideList = ({ overrides, canWrite, onDeactivate }) => {
  if (!overrides || overrides.length === 0) return null;
  return (
    <Box className="overrideList">
      <Typography variant="subtitle2" className="overrideList__header">Active overrides</Typography>
      {overrides.map((o) => (
        <Box key={o.overrideId} className="overrideList__row">
          <Box className="overrideList__rowMain">
            <span className="overrideList__kind">{KIND_LABELS[o.kind] || o.kind}</span>
            <Typography variant="body2" className="overrideList__label">{describe(o)}</Typography>
            {canWrite && (
              <Button
                size="small"
                className="overrideList__button overrideList__button--link"
                onClick={() => onDeactivate?.(o.overrideId)}
              >
                Remove
              </Button>
            )}
          </Box>
          <Box className="overrideList__rowMeta">
            {o.reason && (
              <Typography variant="body2" className="overrideList__reason">“{o.reason}”</Typography>
            )}
            <Typography variant="caption" className="overrideList__attribution">
              Added by {o.createdBy || "unknown"}
              {o.createdAt && ` on ${o.createdAt}`}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default OverrideList;
